import React, { forwardRef, ForwardedRef, useCallback } from 'react';
import styled from 'styled-components';
import { useListenMessage } from 'src/presentation/components/pages/glados/actionAdapters/hooks/useListenMessage';

type IframeProps = {
  src: string;
  loading: boolean;
  handleIframeLoad: (event: React.SyntheticEvent<HTMLIFrameElement, Event>) => void;
  handleIframeError?: (event: React.SyntheticEvent<HTMLIFrameElement, Event>) => void;
  pageName?: string;
};

export const Iframe = forwardRef(
  (
    { src, loading, handleIframeLoad, handleIframeError, pageName }: IframeProps,
    ref: ForwardedRef<HTMLIFrameElement>
  ) => {
    const handleResize = useCallback(
      (event: MessageEvent) => {
        if (event.data.page === pageName && ref && 'current' in ref && ref.current) {
          ref.current.style.height = event.data.height + 'px';
        }
      },
      [ref, pageName]
    );

    useListenMessage(['resize'], handleResize);

    return (
      <>
        <IFrameContainer loading={loading}>
          <IFrame ref={ref} src={src} onLoad={handleIframeLoad} onError={handleIframeError} />
        </IFrameContainer>
      </>
    );
  }
);

const IFrameContainer = styled.div`
  border: none;
  visibility: ${p => (p.loading ? 'hidden' : 'visible')};
  width: ${p => (p.loading ? '0' : '100%')};
`;

const IFrame = styled.iframe`
  border: none;
  width: 100%;
  height: 100vh;
`;
